export const isValidJson = (jsonString: string) => {
  try {
    JSON.parse(jsonString);
    return true; // It can be parsed
  } catch (error) {
    return false; // It cannot be parsed
  }
};
